import { useState } from 'react';
import { Page, Card, BlockStack, TextField, Button, InlineStack, Text } from '@shopify/polaris';
import { CarrierServiceStatusCard } from './CarrierServiceStatusCard';

export function CarrierServicePage(): JSX.Element {
  const [shopDomainInput, setShopDomainInput] = useState('');
  const [activeDomain, setActiveDomain] = useState('');

  return (
    <Page
      title="CarrierService registration"
      subtitle="Register this app as a shipping rate provider"
    >
      <BlockStack gap="400">
        <Card>
          <BlockStack gap="200">
            <Text as="h2" variant="headingMd">Shop</Text>
            <Text as="p" variant="bodyMd">
              Enter the shop domain (e.g. fjord.myshopify.com) to inspect or register its
              CarrierService binding.
            </Text>
            <InlineStack gap="200" align="start" blockAlign="end">
              <div style={{ flex: 1 }}>
                <TextField
                  label="Shop domain"
                  value={shopDomainInput}
                  onChange={setShopDomainInput}
                  autoComplete="off"
                />
              </div>
              <Button onClick={() => setActiveDomain(shopDomainInput.trim())}>Check status</Button>
            </InlineStack>
          </BlockStack>
        </Card>

        {activeDomain ? <CarrierServiceStatusCard shopDomain={activeDomain} /> : null}
      </BlockStack>
    </Page>
  );
}
